<ft-modal-overlay [open]="true">
  <div id="accountv2.ContestContainer" ft-ensure-modal-single-scroll>
    <div class="ft-touchpoint ft-contest">
      <header class="ft-touchpoint-header">
        <button class="ft-btn-close" (click)="closeContainer()"></button>
        <div class="ft-modal-id">
          <div class="ft-supertitle">{{ 'flipto.account.sections.platform.photoAdvocacy.Contest' | translate }}</div>
          <h1 class="ft-modal-name ft-text-plus-3">
            <span [innerHTML]="chc().language?.contestName"></span>
          </h1>
          <ft-switch [state]="!!chc().isActive"
                     (stateChange)="chc().isActive = $event"
                     (change)="updateState()"
                     [disabledControl]="!chc().isEnabled" />
        </div>
      </header>
      <main class="ft-touchpoint-main">
        <ft-sections [registry]="contestsTabs()">
          <!-- Gapless @for: v1 appended the inline-block <li> clones adjacently — with
               preserveWhitespaces:true block whitespace paints ~4px gaps between tabs. -->
          <nav class="ft-nav ft-navbar ft-sections-nav">
            <ul>@for (section of contestsTabs(); track section) {<li (click)="sectionChanged(section)"
                    [class.active]="section.isActive"><a>{{ section.title | capitalize }}</a></li>}</ul>
          </nav>
          <section class="ft-master-section ft-touchpoint-master">
            @switch (activeSection()) {
              @case ('submissions') {
                <ft-contest-submissions-ng [contestUuid]="contestUuid()"
                                           (reviewFinalists)="onReviewFinalists()" />
              }
              @case ('winners') {
                <ft-contest-winners-ng [contestUuid]="contestUuid()" />
              }
              @case ('details') {
                <ft-contest-details-ng [contestUuid]="contestUuid()" />
              }
              @case ('invitations') {
                <ft-contest-invitations-ng [contestUuid]="contestUuid()" />
              }
            }
          </section>
        </ft-sections>
      </main>
    </div>
  </div>
</ft-modal-overlay>
